import { Injectable } from '@angular/core';
import { RegionData } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { of } from 'rxjs';
import { FlyoutLangSelectorExtendedFacade } from './flyout-lang-selector-extended.facade';

@Injectable({
  providedIn: 'root'
})
export class FlyoutLangSelectorHelperFacade extends FlyoutLangSelectorExtendedFacade {
  setListIndex(index: number): void {
    if (this.selectedRegion === this.searchRegionList[index]) {
      this.listIndex = index;
    }
  }

  setSearchCountryList(searchValue: string): void {
    const searchList = this.setSearchList(searchValue);
    if (searchList && searchList?.length > 0) {
      this.searchList$ = of(searchList);
    }
  }

  evaluateIndex(value: RegionData): void {
    if (value?.count !== null && value?.count !== undefined) {
      const aelm = document.querySelectorAll('.region-container li a');
      this.setIndexArray(value?.count, aelm);
    }
  }

  setIndexArray(value: number, aelm: NodeListOf<Element>): void {
    for (let i = 0; i < aelm.length; i++) {
      this.indexArray[i] = false;
    }
    this.indexArray
      ? (this.indexArray[value] = true)
      : (this.indexArray = [true]);
  }
}
